var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home_id_container"}},[_c('br'),_c('h1',[_vm._v("Welcome to Maxton Ehlert's website.")])])}]

export { render, staticRenderFns }